import { render, staticRenderFns } from "./ListResellerServicePage.vue?vue&type=template&id=4f100cb0"
import script from "./ListResellerServicePage.vue?vue&type=script&lang=js"
export * from "./ListResellerServicePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports